import React from "react"
import { useSetState, useEffectOnce } from "react-use"
import { useHistory, useLocation } from "react-router-dom"
import { last } from "lodash"
import { Svg } from "~/components"
import { EllipsisOutlined, EditOutlined } from "@ant-design/icons"
import { Col, Row, Tooltip, Tabs, message } from "antd"
import dayjs from "dayjs"
import { getCamera, updateCamera, removeCamera } from "~/services/apis"
import { useCamera } from "~/hooks"
import SnapshotTab from "./SnapshotTab"
import "./styles.less"

const { TabPane } = Tabs

const DevicePage = () => {
  const history = useHistory()
  const { pathname } = useLocation()
  const id = last(pathname.split("/"))

  //device handlers
  const [camera, setCamera] = useSetState({})

  const handleGetCamera = () => {
    const hideLoading = message.loading("Fetching data.....")
    getCamera(id)
      .then((result) => {
        if (result?.camera) {
          setCamera({
            ...result.camera,
            creator: {
              label: `${result.camera?.creator?.firstName} ${result.camera?.creator?.lastName}`,
              value: result.camera?.creator?.id,
            },
            project: {
              label: result.camera?.project?.name,
              value: result.camera?.project?.id,
            },
            group: {
              label: result.camera?.group?.name,
              value: result.camera?.group?.id,
            },
          })
        }
      })
      .finally(hideLoading)
  }

  useEffectOnce(() => {
    if (id) {
      handleGetCamera()
    }
  })

  const onCameraSubmit = async (values) => {
    const { project, group, creator, ...restValues } = values
    try {
      const result = await updateCamera(id, {
        ...restValues,
        projectId: project?.value,
        groupId: group?.value,
        creatorId: creator?.value,
      })
      hideCameraDrawer()
      message.success("Update camera success !")
      setCamera({ ...result?.updateCamera })
    } catch (e) {
      console.log(e.message)
    }
  }
  const onCameraRemove = async () => {
    try {
      await removeCamera(id)
      hideCameraDrawer()
      message.success("Remove camera success !")
      history.goBack()
    } catch (e) {
      console.log(e.message)
    }
  }

  const {
    show: showCameraDrawer,
    hide: hideCameraDrawer,
    CameraDrawer,
  } = useCamera({
    camera,
    onSubmit: onCameraSubmit,
    onRemove: onCameraRemove,
  })

  const renderSnapshotTab = () => {
    return <SnapshotTab deviceId={id} />
  }

  const tabs = [
    {
      key: "photo",
      label: "Photos",
      render: renderSnapshotTab,
    },
  ]

  return (
    <Row>
      <Row
        gutter={[16, 8]}
        style={{ borderBottom: "1px solid var(--border)", width: "100%", paddingBottom: 10 }}
      >
        <Col
          className={"c-p"}
          onClick={history.goBack}
          style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <Svg name={"back"} style={{ display: "inline-block" }} />
          <span style={{ fontSize: "1rem", fontWeight: 600, color: "var(--green)" }}>
            &nbsp;Back
          </span>
        </Col>
        <Col>
          <Row gutter={16}>
            <Col>
              <img
                alt={"thumbnail"}
                src={
                  camera?.imageUrl ||
                  "data:image/png;base64,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"
                }
                width={40}
                height={40}
              />
            </Col>
            <Col className={"place-center"}>
              <span style={{ fontSize: "1rem", fontWeight: 600, color: "var(--black)" }}>
                {camera?.name || camera?.deviceSerial}
              </span>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={[20, 0]} style={{ marginTop: 16, color: "var(--black)" }}>
        <Col>
          <span style={{ fontWeight: 500 }}>Camera ID: </span> {camera?.id}
        </Col>
        <Col>
          <span style={{ fontWeight: 500 }}>HD View Url: </span> {camera?.hdViewUrl}
        </Col>
        <Col>
          <span style={{ fontWeight: 500 }}>SD View Url: </span> {camera?.sdViewUrl}
        </Col>
        <Col>
          <Tooltip
            overlayInnerStyle={{ width: 300, textAlign: "center" }}
            title={
              <Row>
                <Col span={24}>
                  <span style={{ fontWeight: 500 }}>Last updated: </span>
                  {camera?.updatedAt && dayjs(camera?.updatedAt).format("DD/MM/YYYY hh:mm:ss")}
                </Col>
                <Col span={24}>
                  <span style={{ fontWeight: 500 }}>Created At: </span>
                  {camera?.createdAt && dayjs(camera?.createdAt).format("DD/MM/YYYY hh:mm:ss")}
                </Col>
              </Row>
            }
          >
            <EllipsisOutlined className={"c-p"} />
          </Tooltip>
        </Col>
        <Col>
          <EditOutlined onClick={showCameraDrawer} />
        </Col>
      </Row>
      <CameraDrawer />
      <Row style={{ marginTop: 16, width: "100%" }}>
        <Tabs style={{ width: "100%" }}>
          {tabs.map((tab) => (
            <TabPane key={tab.key} tab={tab.label} style={{ minHeight: 700 }}>
              {tab.render()}
            </TabPane>
          ))}
        </Tabs>
      </Row>
    </Row>
  )
}

export default DevicePage
